<template>
  <div class="drop-zone-wrapper">
    <drop-zone v-for="zone in dropZones" :key="zone.id" :zone="zone"></drop-zone>
  </div>
</template>

<script>
import DropZone from './DropZone';
import { mapGetters, mapState } from 'vuex';
export default {
  components: { DropZone },
  props: {
    dropOptions: {
      type: Object,
      default: () => ({
        accepts: [],
        zones: []
      })
    }
  },
  computed: {
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('components/dragdrop', ['draggedData']),
    // droppable() {
    //   const matchedAccepts = this.dropOptions.accepts.filter(value =>
    //     this.draggedData.types.includes(value)
    //   );
    //   return this.dragging && matchedAccepts.length > 0;
    // },
    dropZones() {
      const allZones = this.dropOptions.zones;
      //return allZones;
      return allZones.filter(z => z.show);
    }
  }
};
</script>

<style>
.drop-zone-wrapper {
  position: absolute;
  pointer-events: none;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
}
</style>
